import calendar from '@/i18n/locales/calendar/kk';
import common from '@/i18n/locales/common/kk';
import errors from '@/i18n/locales/errors/kk';
import help from '@/i18n/locales/help/kk';
import home from '@/i18n/locales/home/kk';
import layout from '@/i18n/locales/layout/kk';
import leads from '@/i18n/locales/leads/kk';
import report from '@/i18n/locales/report/kk';
import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema = {
    calendar,
    common,
    errors,
    help,
    home,
    layout,
    leads,
    report,
};

export default kk;
